export default __webpack_public_path__ + "3f89b4c911984c3d94c00edb127dfb07.png";